import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { makeid } from "../utils/pageactions";

export default function Text({ value, onChange }) {
  const [_value, setValue] = useState("");

  useEffect(() => {
    if (!isNaN(value)) {
      setValue(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const num = parseInt(e.target.value);
    if (!isNaN(num)) setValue(num);
    else setValue("");
  };

  return (
    <div style={{ width: "100%" }}>
      <input
        type="number"
        className={"input"}
        onBlur={() => onChange(_value)}
        value={_value}
        className={styles.textarea}
        onChange={handleChange}
      />
    </div>
  );
}
